import { decodeToken } from 'react-jwt';

import getCapitalizedText from '../helpers/stringHelpers';

export const AUTH_TOKEN = 'auth_token';
export const BETA_MODE_KEY = 'beta_mode_enabled';

export class LocalStorageService {
    private static _instance: LocalStorageService;

    static getInstance(): LocalStorageService {
        if (!this._instance) {
            this._instance = new LocalStorageService();
        }

        return this._instance;
    }

    setLocalStorageValue(key: string, value: string): void {
        localStorage.setItem(key, value);
    }

    getLocalStorageValue(key: string): string | null {
        return localStorage.getItem(key);
    }

    removeLocalStorageValue(key: string): void {
        localStorage.removeItem(key);
    }

    clearLocalStorage(): void {
        localStorage.clear();
    }

    setAuthToken(token: string): void {
        this.setLocalStorageValue(AUTH_TOKEN, token);
    }

    getAuthToken(): string | null {
        return this.getLocalStorageValue(AUTH_TOKEN);
    }

    removeAuthToken(): void {
        this.removeLocalStorageValue(AUTH_TOKEN);
    }

    getLoggedInUserData(token?: string) {
        // Use passed token if available, otherwise fall back to localStorage
        const authToken = token || localStorage.getItem(AUTH_TOKEN);

        if (authToken) {
            const {
                sub,
                name,
                email,
                customer_name,
                customer_id,
                customer_can_demo,
                aam,
                is_beta_user,
            } = decodeToken(authToken) as any;
            return {
                username: sub,
                name,
                aam,
                isBetaUser: is_beta_user,
                isBetaMode: is_beta_user ? true : false,
                customerName: customer_name,
                customerId: customer_id,
                customerCanDemo: customer_can_demo === true,
                formattedName: getCapitalizedText(sub),
                email,
            };
        }
        return {};
    }

    getTokenExpiry() {
        const userToken = localStorage.getItem(AUTH_TOKEN);
        if (userToken) {
            const decodedToken: any = decodeToken(userToken)!;
            if (decodedToken && decodedToken.exp) {
                const expirationTimestamp = decodedToken.exp;

                const expirationDate = new Date(expirationTimestamp * 1000);

                return expirationDate;
            }
        }

        return null;
    }
}

export const localStorageService = LocalStorageService.getInstance();
